import React, { useState, useEffect } from 'react';
import ContactForm from './ContactForm';

const ModalThing = ({ isVisible, onClose, children }) => {
  const handleClose = (e) => {
    if (e.target.id === 'wrapper') onClose();
  };

  return (
    <div
      className={`fixed inset-0 bg-black bg-opacity-25 backdrop-blur-sm flex justify-center items-center ${
        isVisible ? '' : 'hidden'
      }`}
      id="wrapper"
      onClick={handleClose}
      style={{ zIndex: 30 }}
    >
      <div className="max-w-[90vw] sm:max-w-[600px] bg-white p-2 rounded">
        <button
          className="text-white text-xl absolute top-2 right-2"
          onClick={onClose}
        >
          X
        </button>
        {children}
      </div>
    </div>
  );
};

const Modal = () => {
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    const isFirstVisit = localStorage.getItem('isFirstVisit');
    if (!isFirstVisit) {
      localStorage.setItem('isFirstVisit', true);
      setShowModal(true);
    }
  }, []);

  return (
    <ModalThing isVisible={showModal} onClose={() => setShowModal(false)}>
      <ContactForm />
    </ModalThing>
  );
};

export default Modal;
